import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

const LABELS = {
  pto_approved: 'PTO Request Approved',
  pto_denied: 'PTO Request Denied',
  pto_requested: 'New PTO Request (managers)',
  credential_expiring: 'Credential Expiring Soon',
  onboarding_assigned: 'Onboarding Checklist Assigned',
  review_assigned: 'Performance Review Assigned',
  announcement: 'New Announcements',
};

export default function NotificationSettings() {
  const [prefs, setPrefs] = useState([]);

  useEffect(() => {
    api('/hcm/notification-preferences').then(r => r.ok ? r.json() : []).then(setPrefs);
  }, []);

  const toggle = async (type) => {
    const res = await api(`/hcm/notification-preferences/${type}/toggle`, {method: 'POST'});
    if (res.ok) {
      const updated = await res.json();
      setPrefs(prefs.map(p => p.notificationType === type ? updated : p));
    }
  };

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Notification Preferences</h2>
      <div className="bg-white rounded-lg shadow divide-y">
        {prefs.map(p => (
          <div key={p.notificationType} className="flex items-center justify-between px-6 py-4">
            <span className="text-gray-900">{LABELS[p.notificationType] || p.notificationType}</span>
            <button onClick={() => toggle(p.notificationType)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${p.enabled ? 'bg-indigo-600' : 'bg-gray-200'}`}>
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${p.enabled ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
        ))}
        {prefs.length === 0 && <div className="text-center py-8 text-gray-500">Loading...</div>}
      </div>
    </Layout>
  );
}
